(() => {
  if (customElements.get('sample-popup')) {
    return;
  }

  class SamplePopup extends HTMLElement {
    constructor() {
      super();

      this.dialog = this.querySelector('dialog');
    }

    connectedCallback() {
      this.dialog.addEventListener('close', this.handleClose.bind(this));
    }

    disconnectedCallback() {
      this.dialog.removeEventListener('close', this.handleClose.bind(this));
    }

    handleClose() {
      sessionStorage.setItem("sample-popup-closed", "true")
    }
  }

  customElements.define('sample-popup', SamplePopup);
})();
